export default {
    BusinessImportHistory: {
        page: {
            importTemplate: 'Import Template',
            importBatchNumber: 'Import Batch Number',
            totalData: 'Total Data Volume',
            templateName: 'Template Name',
            templateCode: 'Template Code',
            TemplateType: 'Template Type',
            CustomTemplateName: 'Custom Template Name',
            Description: 'Description',

            GeneralImport: 'General import',
            pathPrefix: 'Client path prefix',
            Slicing: 'Fragmentation',
            CustomTemplate: 'Custom template',
            SheetPage: 'Sheet page',
            numberPage: 'Serial number page',
            PageName: 'Page name',
            startLine: 'Import start line',
            templateColumns: 'Maintain template columns',
            PleaseTemplateName: 'Please enter template name',
            PleasetemplateCode: 'Please enter the template code',
            PleaseTemplateType: 'Please select template type',
            PleasePathPrefix: 'Please enter path prefix',
            PleaseSheetPage: 'Please select sheet page',
            PleasePageName: 'Please enter page name',
            SelectFile: 'Select file',

            ColumnCode: 'Column code',
            ColumnName: 'Column name',
            ColumnType: 'Column type',
            FormatMask: 'Format mask',
            Length: 'Length',
            Maximum: 'Max value',
            Minimum: 'Minimum value',
            ValidateValue: 'Value set validation',
            RegularExpression: 'Regular expression',
            NullAllowed: 'Null allowed',
            DataValidation: 'Data validation',
            ColumnNumber: 'Column number',
            SampleData: 'Sample data',
            ValueConversion: 'Value set conversion',
            PleaseSerialNumber: 'Please enter column serial number',
            PleaseColumnNumber: 'Please enter column number',
            PleaseColumnName: 'Please enter column name',
            PleaseColumnType: 'Please enter column type',
            EditColumn: 'Edit column',
            CreateColumn: 'Create new column',
        }
    }
};
